export const getPayerMap = (payers) =>
    (payers ?? []).reduce((prev, curr) => ({ ...prev, [curr.payer_id]: curr.payer_name }), {});

export const getPayerSegmentMap = (payerSegments) =>
    (payerSegments ?? []).reduce((prev, curr) => ({ ...prev, [curr.segment_id]: curr }), {});

export const mapPayerSegment = (segment) => ({
    name: segment?.segment_name,
    secondaryData: segment?.segment_id,
    text: segment?.segment_name,
    value: segment?.segment_id,
    ...segment,
});
